import { message } from 'antd';
import { TransactionListAPI } from './type';
import { API_URL } from '@/env';

const API_USE = API_URL || '';

async function fetchTransactions(page: number, pageSize: number, type: string = 'all'): Promise<TransactionListAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/transactions/me?page=${page}&per_page=${pageSize}&filter_type=${type === 'all' ? '' : type}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch transactions list');
        }
        const data = await response.json();
        if (!data.status || !data.data || data.status === false) {
            message.error(data.message || 'Error fetching transactions list');
            throw new Error(data.message || 'Failed to fetch transactions list');
        }
        return data as TransactionListAPI;
    } catch (error) {
        console.error('Failed to fetch transactions list:', error);
        throw error;
    }
}

export {
    fetchTransactions
};